import { ScenarioStepParameter, VisionStat, VisionStep } from '@wizeoo/akm-message-lib';
import { ScenarioVO } from './scenario.vo';
import { BaselineEngine, VisionVO } from '@wizeoo/akm-compute-lib';
import { Model } from '../../model/model';

/**
 * un paramètre de step pour un VO, encapsulé
 */

export class ScenarioStepParameterVO  {
  
  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }
  public set model(value: Model) {
      this._model = value;
  }
  
  constructor(model: Model, pSource: ScenarioStepParameter, vision: VisionVO, scenario: ScenarioVO) {
    this._model = model;
    this._source = pSource;
    this._vision = vision;
    this._scenario = scenario;
  }

  private _vision: VisionVO;
  private _scenario: ScenarioVO;

  /** L'objet source provenant du back */
  private _source: ScenarioStepParameter;
  public get source(): ScenarioStepParameter {
    return this._source;
  }
  public set source(value: ScenarioStepParameter) {
    this._source = value;
  }

  // level du step
  public get level(): number {
    return this._source.level;
  }
  public set level(value: number) {
    this._source.level = value;
  }

  // libellé du step correspondant
  public get trsLabel(): string {
    let step: VisionStep = BaselineEngine.getVisionStepByLevel(this._vision, this.level);
    let result: string = this.model.visionEngine.getVisionStepLabel(this._vision, step);
    return result;
  }

  public set visible(value: boolean) {
    this._source.visible = value;
  }

  public get visible(): boolean {
    return this._source.visible;
  }

  public set editable(value: boolean) {
    this._source.editable = value;
  }

  public get editable(): boolean {
    return this._source.editable;
  }

  /** nbr de lignes pour ce step sur le scenar */
  public get nbBL(): string {
    let result: string = '';
    let stats: VisionStat = this._scenario.stats;
    
    if(!!stats) {
      stats.lines.forEach(vls => {
        if(vls.stepLevel === this.level) {
          result = vls.nbLines.toString();
        }
      });  
    }
    return result;
  }

  /** nbr de values pour ce step sur le scenar */
  public get nbBLV(): string {
    let result: string = '';
    let stats: VisionStat = this._scenario.stats;
    
    if(!!stats) {
      stats.values.forEach(vvs => {
        if(vvs.stepLevel === this.level) {
          result = vvs.nbLines.toString();
        }
      });  
    }
    return result;
  }

}
